export default __webpack_public_path__ + "media/images/manual/ic/10-9e6e4042452d3cd193644374dcd955e4.png";